:host {
  display: block;
}
.svg-container {
  display: inline-block;
  width: 100%;
}

.svg-container svg {
  display: block;
  width: 100%;
  height: 100%;
}
